module.exports = __webpack_public_path__ + "img/en_lang.11d7ae08.png";